import moment from 'moment'
import {
  FieldTranslation,
  ListFieldTranslation,
  Field,
  ListField,
  TaxonomyTranslationInput,
} from './types'
import { t } from '@lingui/core/macro'
import { trackEvent, EventTrackingEventType } from 'lib/eventTracking'

export const getPercent = (matched = 0, total = 0) =>
  total ? Math.round((matched / total) * 100) : 0

const convertSecondsToMinutes = (seconds = 0) => Math.floor(seconds / 60)

export const getTitleFromSeconds = (seconds: number) => {
  const minutes = convertSecondsToMinutes(seconds)

  if (minutes < 1) return t`< 1 minute`
  if (minutes === 1) return t`1 minute`

  return t`${minutes} minutes`
}

export const formatSecondsToTime = (seconds: number) =>
  moment.utc(seconds * 1000).format(seconds >= 3600 ? 'HH:mm:ss' : 'mm:ss')

export const formatInputNames = (inputs: TaxonomyTranslationInput[]): string[] => {
  return inputs
    .map(input => {
      if (input.source === 'templates') {
        // we don't currently need to show the lists for templates
        if (input.type === 'candidate_list_values' || input.type === 'reference_list_values') {
          return null
        }
        return input.name.replace('.csv', '').split('_')
      }
      return input.name
    })
    .filter(input => input !== null)
    .flat()
}

export const isListTranslation = (
  translation: FieldTranslation,
): translation is ListFieldTranslation => translation.type === 'list'

export const isListField = (field: Field): field is ListField => field.type === 'list'

export const trackItemReviewAction = (properties: {
  source: 'modal' | 'table'
  action: 'skipped' | 'excluded' | 'reviewed'
}) => {
  trackEvent(EventTrackingEventType.TAXONOMY_TRANSLATION_ITEM_REVIEW_ACTION, {
    ...properties,
  })
}

export const trackModalAction = (action: 'opened' | 'closed' | 'done') => {
  trackEvent(EventTrackingEventType.TAXONOMY_TRANSLATION_REVIEW_MODAL_ACTION, {
    action,
  })
}
